import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Image, Divider, Label } from 'semantic-ui-react';
import APIService from '../Services/API/APIService';


const Navbar = () => {


  const [user, setUser] = useState(null)
  const navigate = useNavigate()
  useEffect(() => {

    fetchData()

  }, [])


  const fetchData = async () => {
    try {
      let  response = await APIService.fetchUser()
     
      if(response &&  response.group[0] !== 'GUEST'){
    
        setUser(response)
      }
     
    } catch (error) {

    }
  }


  return (<>
    <Menu secondary stackable   style={{ backgroundColor: 'black' }}>
      <Menu.Item header style={{ backgroundColor: 'transparent' }}><Image src='https://res.cloudinary.com/duknzdiyw/image/upload/v1670859271/coop/coop-logo_svvrp0.png'
        width={200} onClick={() => window.location.href = '/'} /></Menu.Item>
        <Menu.Item style={{ backgroundColor: '#26f09e', color: '#000000',margin: '2px' }}  as={'button'} onClick={() => window.location.href = '/'} > 
            <Label icon={'home'} content={'Home'} style={{ backgroundColor: '#26f09e', color: '#000000' }} /></Menu.Item>
      <Menu.Menu position='right'>
        {user ? (
          <>
            <Menu.Item style={{ backgroundColor: '#26f09e', color: '#000000',margin: '2px' }}  as={'button'} onClick={() => navigate('profile')} > 
            <Label icon={'user circle'} content={user?.firstname || user?.email} style={{ backgroundColor: '#26f09e', color: '#000000' }} /></Menu.Item>
            <Menu.Item style={{ backgroundColor: '#26f09e', color: '#000000',margin: '2px' }} as={'button'} onClick={() => navigate('past-bookings') }> 
            <Label icon={'list'} content={'Past Booking'}  style={{ backgroundColor: '#26f09e', color: '#000000' }} /></Menu.Item>
            <Menu.Item style={{ backgroundColor: '#26f09e', color: '#000000',margin: '2px' }} as={'button'} onClick={() => APIService.signOut()} icon={'sign-out'}>
              <Label icon={'sign-out'} content={'Sign out'}  style={{ backgroundColor: '#26f09e', color: '#000000' }} />
              </Menu.Item>
          </>
        ) : (

          <>
            <Menu.Item style={{ backgroundColor: '#26f09e', color: '#000000',margin: '2px' }} as={'a'} href={'/login'}>
            <Label icon={'lock'} content={'Login'}  style={{ backgroundColor: '#26f09e', color: '#000000' }} />
            </Menu.Item>
            <Menu.Item style={{ backgroundColor: '#26f09e', color: '#000000',margin: '2px' }} as={'a'} href={'/register'}>
            <Label icon={'sign-in'} content={'Register'}  style={{ backgroundColor: '#26f09e', color: '#000000' }} />
            </Menu.Item>
          </>
        )}

      </Menu.Menu>
    </Menu>
    <Divider />

  </>)
}

export default Navbar;
